export default {
    apiKey: "AIzaSyChAlws_drVXn0Mh9ldOFVMCiTIe5BoVhk",
    authDomain: "spitlord-site.firebaseapp.com",
    projectId: "spitlord-site",
    storageBucket: "spitlord-site.appspot.com",
    messagingSenderId: "127951483396",
    appId: "1:127951483396:web:45a17a72853ef7f446bb51"
}
